<h4 class="title-center">Revision History</h4>
<div class="inline" style="padding: 10px;">
  <app-lt-switch [(ngModel)]="historyChecked" [onLabel]="'XML'" [offLabel]="'JS'" (toggleChange)="clearHistory()"></app-lt-switch>
</div>

<ng-container *ngIf="historyChecked === true">
  <ng-container *ngIf="integrationHistoryLoading === true">
    <div class="loading-display">
      <app-lt-spinner></app-lt-spinner>
    </div>
  </ng-container>
  <ng-container *ngIf="integrationHistoryLoading === false">
    <mat-form-field appearance="fill" class="dropdown-med-width">
      <mat-label>Integration History</mat-label>
      <mat-select name="i" (selectionChange)="selectIntegrationHistory($event.value)">
        <mat-option>--</mat-option>
        <mat-option *ngFor="let i of integrationHistory" [value]="i">
          {{ i.updatedDate | date: 'MM/dd/yyyy h:mm a'}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</ng-container>

<ng-container *ngIf="historyChecked === false">
  <ng-container *ngIf="javaScriptHistoryLoading === true">
    <div class="loading-display">
      <app-lt-spinner></app-lt-spinner>
    </div>
  </ng-container>
  <ng-container *ngIf="javaScriptHistoryLoading === false">
    <mat-form-field appearance="fill" class="dropdown-med-width">
      <mat-label>Destination Endpoint</mat-label>
      <mat-select name="d" [formControl]="endpointFormControl" (selectionChange)="selectEndpointType($event.value)">
        <mat-option>--</mat-option>
        <mat-option *ngFor="let d of filteredDestinationEndpoints" [value]="d">
          {{ d.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    Compare Current to:

    <mat-form-field appearance="fill" class="dropdown-med-width" *ngIf="selectedEndpoint">
      <mat-label>Javascript History Compare</mat-label>
      <mat-select name="i" (selectionChange)="selectJsIntegrationCompare($event.value)">
        <mat-option>--</mat-option>
        <mat-option *ngFor="let i of filterJavascriptHistoryList(selectedEndpoint)" [value]="i">
          {{ getDestName(i.destinationEndpointId)}} | {{ i.updatedDate | date: 'MM/dd/yyyy h:mm a' }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

</ng-container>

<ng-template *ngIf="historyChecked; then int1 else int2"></ng-template>

<ng-template #int1>
  <div *ngIf="selectedIntegrationHistory && !integrationHistoryLoading"  class="monaco-outer">
    <div>
      <app-monaco-diff-editor #monacoHistory
                  [currentData]="historyRawData"
                  [historyData]="historyData"
                  [lang]="monacoLangHtml"
                  [historyTitle]="historySideTitle"
                  [currentTitle]="currentSideTitle">
      </app-monaco-diff-editor>
    </div>
    <div class="center-button">
      <button matButton="elevated"
        *ngIf="checkAccess(['LOSTalker.DevOps.Write'])"
        (click)="updateIntegrationFromHistory('xml')">
        Revert to Selected History
      </button>
    </div>
  </div>
</ng-template>

<ng-template #int2>
  <div *ngIf="selectedJavascript && selectedJavascriptCompare && !javaScriptHistoryLoading" class="monaco-outer">
    <div>
      <app-monaco-diff-editor #monacoJSHistory
                  [currentData]="historyRawData"
                  [historyData]="historyData"
                  [lang]="monacoLangJs"
                  [historyTitle]="historySideTitle"
                  [currentTitle]="currentSideTitle">
      </app-monaco-diff-editor>
    </div>
    <div class="center-button">
      <button matButton="elevated"
        *ngIf="checkAccess(['LOSTalker.DevOps.Write'])"
        (click)="updateIntegrationFromHistory('js')">
        Revert to Selected History
      </button>
    </div>
  </div>
</ng-template>
